module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon02.5a26acaf.svg";